<div class="tab-content">
  <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show">
    <spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
    <div class="row">
      <div class="col-md-12">
        <div class="tab" role="tabpanel">
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'setwindow'}" (click)="navtabclick('setwindow')" name="setwindow"
                aria-selected="true">{{ 'trigManage.setwindow' | translate}}</a></li>
            <li role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'requestextension'}" (click)="navtabclick('requestextension')"
                name="requestextension" aria-selected="false">{{ 'trigManage.extensionapproval' | translate}}</a></li>

          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade active show" id="pending" *ngIf="activesidetab == 'setwindow'">
              <div class="col-auto text-right">
                <!-- <button  [disabled]="!enablesetwindow" class="btn btn-primary pull-right pointer" name="download" (click)="openwindowmodel(null)">Set Window</button> -->
                <button class="btn btn-info pull-right pointer" name="download"
                  (click)="openwindowmodel(null)">{{"trigManage.setwindow" | translate}}</button>
              </div>


              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm">

                    <cdk-virtual-scroll-viewport #scrollViewport itemSize="50" style="height:185px">
                      <table class="table table-striped text-center table-sm mt-1">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col" class="positiontest" [style.top]="inverseOfTranslation">
                              {{'trigManage.sno' | translate}}</th>
                            <th>{{'header.assesmentyear' | translate}}</th>
                            <th>{{'dataSubs.month' | translate}}</th>
                            <th>{{'dataSubs.Start Date' | translate}}</th>
                            <th>{{'dataSubs.End Date' | translate}}</th>
                            <th>{{'dataSubs.Edit/Delete' | translate}}</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="!shownodata">
                          <ng-container *ngFor="let table of windowtabledata | keyvalue;let i=index">
                            <tr>
                              <td>{{i+1}}</td>
                              <td>{{getYearAndMonth(table['key'],0)}}</td>

                              <!-- <td>{{table['key'] | slice:0:9}}</td> -->
                              <td>{{'monthmaps.' + getYearAndMonth(table['key'],1) | translate}}</td>
                              <td>{{formatdate(table['value']['sdate'])}}</td>
                              <td>{{formatdate(table['value']['edate'])}}</td>
                              <td>
                                <div class="d-flex justify-content-center">
                                  <div class="text-warning mx-2 pull-right pointer"
                                    (click)=" openEditmodel(table['key'])"><i class="fas fa-edit"></i></div>
                                  <div class="text-danger mx-2 pull-right pointer" (click)="deletewindow(table['key'])">
                                    <i class="fas fa-trash"></i></div>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </cdk-virtual-scroll-viewport>

                    <div class="row" *ngIf="shownodata">
                      <div class="col-12 nodata">
                        {{'infotab.nodata' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
            <div role="tabpanel" class="tab-pane fade active show" id="pending"
              *ngIf="activesidetab == 'requestextension'">
              <div class="row">
                <div class="col-12 col-xl mb-2 mb-xl-0">
                  <div>
                    <label>{{'header.assesmentyear' | translate}}<span class="text-star">*</span></label>
                    <select [(ngModel)]="assesmentyear" class="form-control custom-selectbox">
                      <option value="">{{'trigManage.selectassessmentyear' | translate}}</option>
                      <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                    </select>
                    <span style="color:red" [hidden]="validation[0]">{{ 'dataSubs.pleaseSelectassessmentyear' | translate }} </span>
                  </div>
                </div>

                <div class="col-12 col-xl mb-2 mb-xl-0">
                  <div>
                    <label>{{'dataSubs.month' | translate }}<span class="text-star">*</span></label>
                    <select [(ngModel)]="selectedMonth" class="form-control custom-selectbox">
                      <option value="">{{'monthmaps.selcecttag' | translate}}</option>
                      <option *ngFor="let month of monthlist" value="{{month.key}}">
                        {{'monthmaps.' + month['value'] | translate}}</option>
                    </select>
                    <span style="color:red" [hidden]="validation[0]">{{ 'dataSubs.pleaseselectmonth' | translate }} </span>
                  </div>
                </div>

                <div class="col-12 col-xl mb-2 mb-xl-0">
                  <div>
                    <label>{{'header.state' | translate }}<span class="text-star">*</span></label>
                    <select [(ngModel)]="selectedstate" class="form-control custom-selectbox"
                      (change)="showdistrictdropdown(selectedstate)">
                      <option value="undefined">{{'tabledataforstates.selectstate' | translate}}</option>
                      <option *ngFor="let state of stateArrayList" value="{{state['uuid']}}">
                        {{'tabledataforstates.' + state.name | translate}}</option>
                    </select>
                    <span style="color:red"
                      [hidden]="validation[1]">{{'tabledataforstates.pleaseselectstate' | translate}} </span>
                  </div>
                </div>

                <div class="col-12 col-xl mb-2 mb-xl-0" *ngIf="showdistdrop">
                  <div >
                    <label>{{'header.district' | translate}}</label>
                    <div *ngIf="selectedlanguage=='en'">
                      <ng-multiselect-dropdown placeholder="{{ 'districtsdata.select' | translate}}"
                        [data]="DistrictList" [(ngModel)]="selecteddistrict" [settings]="dropdownSettings"
                        (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                        (onDeSelect)="onItemDeSelect($event)" (onDeSelectAll)="onItemDeSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                    <div *ngIf="selectedlanguage=='hi'">
                      <ng-multiselect-dropdown placeholder=" {{ 'districtsdata.select' | translate}}"
                        [data]="DistrictList" [settings]="hindidropdownSettings" (onSelect)="onItemSelect($event)"
                        (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)"
                        (onDeSelectAll)="onItemDeSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>

                <div class="col-auto d-flex justify-content-end align-items-end">
                  <div>
                    <button class="btn btn-info btn-sm mr-2" (click)="getTableData()" name="submit"
                      type="button">{{'submitdata.edit' | translate }}</button>
                  </div>
                </div>

                <div class="col-auto w-100 d-flex justify-content-end align-items-end mt-2">
                  <div class="btn-group ">
                    <button class="btn btn-info btn-sm mr-2" (click)="approveOrrejectclick('approve')" name="submit"
                      type="button">{{'trigManage.accept' | translate}}</button>
                    <button class="btn btn-danger btn-sm" (click)="approveOrrejectclick('reject')" name="reject"
                      type="button">{{'dataSubs.reject' | translate}}</button>
                  </div>
                </div>


              </div>

              <div class="row" *ngIf="showtable">
                <div class="col-md-12">
                  <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm">

                    <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
                      [style.height]="tableData.length > 0 ? '500px' : '185px'">
                      <table class="table table-striped text-center table-sm mt-1">
                        <thead class="thead-light">
                          <tr>
                            <th class="positiontest" [style.top]="inverseOfTranslation">
                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" (change)="checkallset(checkall)" name="selectall"
                                  [disabled]="disablechackall" [(ngModel)]="checkall" class="custom-control-input"
                                  id="selectall">
                                <label class="custom-control-label pointer" for="selectall"></label>
                              </div>
                              <input type="checkbox" name="selectall" class="custom-control-input" id="selectall">
                            </th>
                            <th scope="col" class="positiontest" [style.top]="inverseOfTranslation">
                              {{'dataSubs.sno' | translate}}</th>
                            <th>{{'dataSubs.distname' | translate}}</th>
                            <th>{{'dataSubs.Start Date' | translate}}</th>
                            <th>{{'dataSubs.End Date' | translate}}</th>
                            <th>{{'dataSubs.Proposed End Date' | translate}}</th>
                            <th>{{'dataSubs.Reason' | translate}}</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="!shownodata">
                          <ng-container *ngFor="let table of tableData | keyvalue;let i=index">
                            <tr>
                              <td>
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input"
                                    [(ngModel)]="table['value']['ischecked']" id="{{i+1}}">
                                  <label class="custom-control-label pointer" for="{{i+1}}"></label>
                                </div>
                              </td>
                              <td>{{i+1}}</td>
                              <td>{{'districtsdata.' + table['value']['name'] | translate}}</td>
                              <td>{{formatdate(table['value']['sdate'])}}</td>
                              <td>{{formatdate(table['value']['edate'])}}</td>
                              <td>{{formatdate(table['value']['extensiondate'])}}</td>
                              <td>{{table['value']['reason']}}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </cdk-virtual-scroll-viewport>

                    <div class="row" *ngIf="shownodata">
                      <div class="col-12 nodata">
                        {{'infotab.nodata' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>